import { render, staticRenderFns } from "./UserEnrollmentInformation.vue?vue&type=template&id=cfbbdf5e&"
import script from "./UserEnrollmentInformation.vue?vue&type=script&lang=js&"
export * from "./UserEnrollmentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
